define([
    'underscore'
], (_)=> {
    return [function () {
        return {
            restrict: 'EA',
            // template: template,
            scope: {
                trigger: '@', // hover|click
                side: '@' // top|bottom|right|left
            },
            link: (scope, element)=> {
                const tooltipOptions = {
                    // we detach the content from the page and give it to the tooltip
                    content: element.find('>content').detach(),
                    contentCloning: false,
                    interactive: true,
                    maxWidth: 480,
                    distance: 0,
                    animationDuration: 200,
                    delay: [0, 600],
                    delayTouch: [0, 600]

                    // http://iamceege.github.io/tooltipster/
                    // minIntersection
                    // timer
                    // zIndex
                    // IEmin: 11
                };

                // TRIGGER OPTION
                if (scope.trigger) {
                    tooltipOptions.trigger = scope.trigger;
                } else {
                    tooltipOptions.trigger = 'hover';
                }

                // hover on mobile devices should be tap
                if ('ontouchstart' in window &&
                    tooltipOptions.trigger === 'hover') {
                    _.extend(tooltipOptions, {
                        trigger: 'custom',
                        triggerOpen: {
                            mouseenter: true,
                            touchstart: true
                        },
                        triggerClose: {
                            click: true,
                            scroll: true,
                            tap: true
                        }
                    });
                }

                // SIDE OPTION
                if (scope.side) {
                    tooltipOptions.side = scope.side;
                }

                // INIT
                const $tooltip = element.find('>opener').tooltipster(tooltipOptions);

                // ON DESTROY
                scope.$on('$destroy', ()=> {
                    $tooltip.tooltipster('destroy');
                });
            }
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/tooltip/directives/TooltipDirective.js